import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useToast } from '../../components/Toast';
import { searchGettingStartedFaq } from '../../data/support/gettingStartedFaq';
import { searchFeaturesFaq } from '../../data/support/featuresFaq';
import { searchWorksheetFaq } from '../../data/support/worksheetFaq';
import { searchPaymentFaq } from '../../data/support/paymentFaq';
import { searchTechnicalFaq } from '../../data/support/technicalFaq';
import { findSupportFaq } from './supportFaqIndex';
import {
  SupportFaqList,
  SupportGuideLayout,
  SupportHelpFooter,
  SupportLinkList,
  SupportSearch,
  openChannelTalk,
} from './SupportGuide';

export const searchAllSupportFaq = (query) => [
  ...searchGettingStartedFaq(query),
  ...searchFeaturesFaq(query),
  ...searchWorksheetFaq(query),
  ...searchPaymentFaq(query),
  ...searchTechnicalFaq(query),
];

export const POPULAR_FAQ_IDS = ['getting-started-001', 'features-002', 'features-014', 'payment-003', 'technical-003'];

export const SUPPORT_TOPICS = [
  { to: '/support/getting-started', title: '처음 시작하기', body: '가입, 무료로 쓸 수 있는 범위, 모바일' },
  { to: '/support/features', title: '기능별 사용법', body: '생기부·검사기·채점·평가계획서·PPT·한글 문서' },
  { href: '/docs/whatquiz-manual.pdf', title: '사용 매뉴얼 PDF', body: '가입·쿠폰 등록부터 기능 사용까지 화면으로 따라 하기' },
  { to: '/support/worksheet', title: '학습지 만들기', body: '문제·정답 만들기, 한글(HWP) 파일' },
  { to: '/support/payment', title: '결제·이용권', body: '요금, 기간 연장, 환불, 세금계산서' },
  { to: '/support/technical', title: '로그인·오류 해결', body: '로그인이 안 될 때, PRO가 안 보일 때' },
  { to: '/help', title: '새 기능·공지', body: '업데이트와 공지사항 모아 보기' },
];

const SupportPage = () => {
  const { showToast } = useToast();
  const popularFaqs = POPULAR_FAQ_IDS.map(findSupportFaq).filter(Boolean);

  return (
    <>
      <Helmet>
        <title>고객센터 | 생기부·PPT·학습지·이미지·채점 사용 가이드 | 왓퀴즈</title>
        <meta name="description" content="왓퀴즈 사용 가이드. 생기부 AI 작성, PPT 만들기, 학습지 생성, 이미지 생성, 수행평가 채점 등 모든 기능 사용법과 FAQ. 교사 인증, 결제, 구독 안내까지." />
        <meta name="keywords" content="왓퀴즈 사용법, 교사 AI 사용 가이드, 생기부 AI 사용법, PPT 만들기 가이드, 학습지 만들기, AI 이미지 생성, 왓퀴즈 고객센터, 왓퀴즈 FAQ" />
        <meta property="og:title" content="고객센터 | 생기부·PPT·학습지·이미지·채점 사용 가이드 | 왓퀴즈" />
        <meta property="og:description" content="생기부, PPT, 학습지, 이미지, 채점 FAQ와 상담을 안내해요." />
        <meta property="og:type" content="website" />
        <link rel="canonical" href="https://whatquiz.co.kr/support" />
      </Helmet>

      <SupportGuideLayout>
        <section className="sg__hero">
          <h1>무엇을 도와드릴까요?</h1>
          <p>궁금한 걸 검색하거나 아래에서 주제를 골라 보세요</p>
          <SupportSearch
            search={searchAllSupportFaq}
            placeholder="예: 생기부 여러 명, 환불, 한글 파일"
          />
        </section>

        <section className="sg__card">
          <h2>주제별 도움말</h2>
          <SupportLinkList items={SUPPORT_TOPICS} />
        </section>

        <section className="sg__card">
          <h2>많이 묻는 질문</h2>
          <SupportFaqList faqs={popularFaqs} openFirst={false} />
        </section>

        <SupportHelpFooter onChat={() => openChannelTalk(showToast)} />
      </SupportGuideLayout>
    </>
  );
};

export default SupportPage;
